<template>
  <div class="manual-content card-item">
    <h3 class="text-align-center">Realiza tu transferencia</h3>
    <div class="transfer-process">
      <div class="transfer-card card-animation-content">
        <div class="card-item front-card">
          <div class="title-card">
            <h4 class="is-pulled-left">Inicia</h4>
            <div class="icon-front is-pulled-right">
              <img src="@/ui/assets/img/instrucciones.svg">
            </div>
            <div class="is-clearfix" />
          </div>
          <p>¿Cómo <b>transferir</b> desde tu banco?</p>
          <ol class="transfer-steps">
            <li>Ingresa a la app o página web de tu banco</li>
            <li>Agrega un nuevo destinatario con los datos de Creditú</li>
            <li>Transfiere el total, desde una cuenta con tu Rut</li>
          </ol>
          <p class="has-text-centered">
            <button
              id="button-view-bank-account"
              :class="{ 'is-hidden': isClicked }"
              class="button is-button-primary is-rounded"
              @click="isClicked = true">
              Ver datos
            </button>
          </p>
        </div>
      </div>
      <div class="transfer-card card-animation-content">
        <div
          id="transfer-image"
          :class="{ 'rotate-left-leave-to': isClicked }"
          class="card-item front-card">
          <h4 class="has-text-centered">Transfiere</h4>
          <div class="icon-back"><img src="@/ui/assets/img/transfiere.svg"></div>
        </div>
        <div class="anchor">
          <div id="anchor-mobile-transfer" />
        </div>
        <div
          id="data-card"
          :class="{ 'rotate-left-enter-to': isClicked, 'show': isClicked }"
          class="card-item back-card">
          <div class="title-card">
            <h4 class="is-pulled-left">Transfiere</h4>
            <div class="icon-front is-pulled-right"><img src="@/ui/assets/img/transfiere.svg"></div>
            <div class="is-clearfix" />
          </div>
          <p>Datos de la cuenta destino:</p>
          <ul class="account-data">
            <li>
              <div class="is-pulled-left"><span class="label">Titular</span>Creditu S.A.</div>
              <a class="is-pulled-right" href="javascript:void(0);" @click="copy($event)"><i
                class="far fa-copy fa-lg" /></a>
              <div class="is-clearfix" />
            </li>
            <li>
              <div class="is-pulled-left"><span class="label">RUT</span>76.594.721-9</div>
              <a class="is-pulled-right" href="javascript:void(0);" @click="copy($event)"><i
                class="far fa-copy fa-lg" /></a>
              <div class="is-clearfix" />
            </li>
            <li><span class="label">Banco</span>Banco de Crédito e Inversiones (BCI)</li>
            <li><span class="label">Tipo de cuenta</span>Cuenta Corriente</li>
            <li>
              <div class="is-pulled-left"><span class="label">Número de cuenta</span>35428546</div>
              <a class="is-pulled-right" href="javascript:void(0);" @click="copy($event)"><i
                class="far fa-copy fa-lg" /></a>
              <div class="is-clearfix" />
            </li>
            <li>
              <div class="is-pulled-left">
                <span class="label">Correo electrónico</span>pagos@creditu.com
              </div>
              <a class="is-pulled-right" href="javascript:void(0);" @click="copy($event)"><i
                class="far fa-copy fa-lg" /></a>
              <div class="is-clearfix" />
            </li>
          </ul>
        </div>
      </div>
      <div class="transfer-card card-animation-content">
        <div
          :class="{ 'rotate-left-leave-to': isClicked }"
          class="card-item front-card">
          <h4 class="has-text-centered">Confirma</h4>
          <div class="icon-back"><img src="@/ui/assets/img/confirma.svg"></div>
        </div>
        <div
          :class="{ 'rotate-left-enter-to': isClicked, 'show': isClicked }"
          class="card-item back-card">
          <div class="title-card">
            <h4 class="is-pulled-left">Confirma</h4>
            <div class="icon-front is-pulled-right"><img src="@/ui/assets/img/confirma.svg"></div>
            <div class="is-clearfix" />
          </div>
          <div class="confirm-card-content">
            <div>
              ¿Vas a transferir desde la cuenta de un conocido?
              <button
                id="button-add-trusted-id-number"
                class="button is-button-secondary is-rounded is-small"
                href="#anchor-mobile-transfer"
                @click="$emit('open-trusted-ids-modal', true)">
                Agregar persona de confianza
              </button>
            </div>
            <div>
              <p class="has-text-centered">¿Ya realizaste la <b>transferencia</b>?</p>
              <div class="buttons is-centered">
                <button
                  id="button-already-transferred"
                  class="button is-button-primary is-rounded is-small"
                  @click="triggerModal">
                  Sí, ya la hice
                </button>
                <button
                  id="button-didnt-transfer"
                  class="button is-button-secondary is-rounded is-small"
                  href="#anchor-mobile-transfer"
                  @click="shakeSenora">
                  No, aún no
                </button>
              </div>
            </div>
            <div>
              <p class="has-text-centered">
                Recuerda enviar tu(s) comprobante(s) a <b>pagos@creditu.com</b>
              </p>
              <p class="has-text-centered" style="color:red;">{{ errorMessage }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PayWireTransfer',
  data() {
    return {
      isClicked: false,
      focusCard: false,
      isCallingBackend: false,
      errorMessage: ''
    };
  },
  created() {
    this.$parent.$on('create-transaction', this.createTransaction);
  },
  beforeDestroy() {
    this.$parent.$off('create-transaction');
  },
  mounted() {
    this.$parent.$on('create-transaction', this.createTransaction);
    this.$emit('sendNameBackStep', 'payment-provider');
  },
  methods: {
    shakeSenora() {
      this.errorMessage = '';
      const element = this.$el.querySelector('#data-card');
      element.classList.remove('shaking');
      // eslint-disable-next-line no-unused-expressions
      element.offsetWidth;
      element.classList.add('shaking');
    },
    copy(event) {
      this.$copyText(event.path[2].childNodes[0].childNodes[1].data);
    },
    async createTransaction() {
      if (this.isCallingBackend) {
        return;
      }
      this.isCallingBackend = true;
      this.$emit('open-confirm-transaction-modal', false);
      this.$store.dispatch('setPaymentMethod', '');
      try {
        const transactionDataIn = this.$store.state.paymentsModule.transactionData;
        transactionDataIn.comment = 'Pago será confirmado en 24 hrs. hábiles';
        transactionDataIn.paymentsMethodName = 'Transferencia manual';
        this.$store.dispatch('setTransactionData', transactionDataIn);
        this.$router.push({ name: 'choice' }).catch(error => {
          this.$log.error(error.message);
        });
      } catch (_error) {
        this.errorMessage = 'Ha ocurrido un error al comunicarse con el servidor';
      }
      this.isCallingBackend = false;
    },
    triggerModal() {
      this.errorMessage = '';
      this.$el.querySelector('#data-card').classList.remove('shaking');
      this.$emit('open-confirm-transaction-modal', true);
    }
  }
};
</script>
<style scoped>
.manual-content {
  margin: 30px auto 50px auto;
}

.transfer-process {
  display: flex;
  flex-flow: row wrap;
  font-size: 12px;
}

.transfer-process .transfer-card {
  width: calc(100% / 3 - 30px);
  margin: 15px;
  flex: 1 0 auto;
}

.transfer-process .transfer-card .card-item {
  height: 100%;
  margin-bottom: 10px;
}

.transfer-process .transfer-card .card-item .focusCard {
  box-shadow: var(--primary);
}

.transfer-process .transfer-card .title-card {
  margin-bottom: 20px;
}

.transfer-process .transfer-card .icon-front {
  width: 60px;
}

.transfer-process .transfer-card .icon-back {
  width: 100%;
  max-width: 160px;
  margin: 40px auto 0px auto;
}

.account-data li {
  border-bottom: 1px solid #cccccc;
  font-size: 12px;
  margin-top: 5px;
  padding: 2px 0;
}

.account-data li span.label {
  font-size: 8px;
  font-weight: bold;
  display: block;
}

.account-data li .fa-copy {
  margin-top: 13px;
  margin-right: 15px;
}

.account-data li a.is-pulled-right {
  transition: filter 0.3s ease 0.3s;
}

.account-data li a.is-pulled-right:active {
  filter: drop-shadow(0 0 0 red);
  transition: filter 0s;
}

.transfer-steps {
  list-style: none;
  padding-left: 1rem;
  counter-reset: circle-counter;
  margin: 20px 0px;
}

.transfer-steps li {
  counter-increment: circle-counter;
  margin-bottom: 1rem;
  padding-left: 15px;
  position: relative;
}

.transfer-steps li::before {
  content: counter(circle-counter);
  background: var(--primary);
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  display: inline-block;
  font-size: 0.75rem;
  line-height: 1.5rem;
  color: #fff;
  text-align: center;
  margin-right: 0.5rem;
  position: absolute;
  top: -2px;
  left: -15px;
}

.confirm-card-content {
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
  align-items: center;
  gap: 2rem;
}

.confirm-card-content div {
  display: flex;
  flex-flow: column wrap;
  justify-content: center;
  align-items: center;
  gap: 0.5rem 1rem;
}

@media (max-width: 1100px) {
  .transfer-process {
    font-size: 10px;
  }

  .transfer-process .transfer-card .icon-front {
    width: 40px;
  }

  .title-card h4 {
    font-size: 16px;
  }

  .account-data li {
    font-size: 10px;
  }
}

@media (max-width: 870px) {
  .transfer-process .transfer-card {
    width: 100%;
    max-width: 400px;
    margin: 15px auto;
  }

  .transfer-process {
    font-size: 12px;
  }

  .transfer-process .transfer-card .icon-front {
    width: 60px;
  }

  .title-card h4 {
    font-size: 20px;
  }

  .account-data li {
    font-size: 12px;
  }

  .anchor {
    position: relative;
  }

  #anchor-mobile-transfer {
    position: absolute;
    margin-top: -65px;
  }
}

.shaking {
  animation: shake 0.82s cubic-bezier(.36, .07, .19, .97) both;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000px;
  box-shadow: 0px 0px 10px var(--primary);
}

@keyframes shake {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }
  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }
  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }
  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}
</style>
